const landingPath = "/";
const loginPath = "/login";
const signUpPath = "/signup";
const academyPath = "/academy";
const single = ":single_id";
const eachstudentPath = `${academyPath}/${single}`;
const studentPath = "/student";
const forgotPasswordPath = "/forgot-password";
const booksPath = "/books";
const aboutPath = "/about";
const changePasswordPath = "/change-password";
const blogPath = "/blog";
const pricingPath = "/pricing";
const waitListPath = "/wait-list";
const dashboardPath = "/dashboard";
const quranPath = "/quran";
const learningToolsPath = "/learning-tools";
const qiraatPath = "/Qiraat";
const contactPath = "/contact";
const InstructorsPath = "/instructor";
const indInstrutor = ":instructor_id";
const eachInstrutor = ` ${InstructorsPath}/${indInstrutor}`;

export {
  contactPath,
  academyPath,
  booksPath,
  eachstudentPath,
  studentPath,
  dashboardPath,
  waitListPath,
  forgotPasswordPath,
  pricingPath,
  InstructorsPath,
  aboutPath,
  blogPath,
  changePasswordPath,
  signUpPath,
  loginPath,
  landingPath,qiraatPath,
  eachInstrutor,learningToolsPath,
  quranPath, 
};

// ADD OTHER ROUTE PATHS
